import React, { useEffect } from "react";
import styled from "styled-components";
import { Mountain } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LoginContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  color: #000;
  font-size: 1.1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(208, 208, 208, 0.78);
  transition: background 0.2s;
  &:hover {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(208, 208, 208, 0.58);
  }
`;

const SidebarLogo = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  padding: 0 0 32px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #000;
  justify-content: center;
`;

export default function Login() {
  const navigate = useNavigate();

  // Check if user is already authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch("/auth/me");
        if (res.ok) {
          const userData = await res.json();
          if (userData) {
            navigate("/app");
          }
        }
      } catch (err) {
        // User not authenticated, stay on login page
      }
    };

    checkAuth();
  }, [navigate]);

  const handleGoogleLogin = () => {
    window.location.href = "/auth/google";
  };

  return (
    <LoginContainer>
      <div>
        <SidebarLogo>
          <Mountain size={28} style={{ marginRight: -7, marginBottom: 5 }} />
          LastRun
        </SidebarLogo>
        <LoginButton onClick={handleGoogleLogin}>
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google"
            style={{ width: "20px", height: "20px" }}
          />
          Sign in with Google
        </LoginButton>
      </div>
    </LoginContainer>
  );
}
